/*
 * moduleName: 学生列表tabs数量
 * description:学生列表tabs数量
 */
import * as actionTypes from '../actionType';

const defalutState = {
  studentStatistics: {},
  studentStatisticsParams: {},
  currentReverseAddFriendCount: 0,
  reverseAddFriendResultObject: {}
};
export default {
  studentStatisticsParams(state = defalutState.studentStatisticsParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_STUDENTSTATISTICS_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  studentStatistics(state = defalutState.studentStatistics, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_STUDENTSTATISTICS:
        return payload;
      default:
    }

    return state;
  },
  currentReverseAddFriendCount(state = defalutState.currentReverseAddFriendCount, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_CURRENT_REVERSE_ADD_FRIEND_COUNT:
        return payload;
      default:
    }

    return state;
  },
  reverseAddFriendResultObject(state = defalutState.reverseAddFriendResultObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_REVERSE_ADD_FRIEND_RESULT_OBJECT:
        return payload;
      default:
    }

    return state;
  },
};
